export default "__VITE_ASSET__BA7JrkPa__"